import { InternalLocale } from '@catawiki/locale';

export const queryKeys = {
  sellerProfile: ['sellerProfile'] as const,
  sellerPreferences: ['sellerPreferences'] as const,
  actionableLotsHbo: (locale: InternalLocale) => ['actionableLotsHbo', locale],
};
